module.exports = __webpack_public_path__ + "img/gnt.83205280.svg";